import { routeNames } from "./constants/routeNames";
import { PreEntry } from "./pages/SimplePages/PreEntry";
import { OutOfHours } from "./pages/SimplePages/OutOfHours";
import { Closed } from "./pages/SimplePages/Closed";
import { Terms } from "./pages/SimplePages/Terms";
import { Privacy } from "./pages/SimplePages/Privacy";
import { Cookies } from "./pages/SimplePages/Cookies";
import { AlreadyEntered } from "./pages/SimplePages/AlreadyEntered";
import { NotWinner } from "./pages/SimplePages/NotWinner";
import { Signup } from "./pages/Signup/Signup";
import { AskLocation } from "./pages/AskLocation/AskLocation";
import { Venues } from "./pages/Venues/Venues";
import { SignupSuccess } from "./pages/SignupSuccess/SignupSuccess";
import { Scan } from "./pages/Scan/Scan";
import { Winner } from "./pages/Winner/Winner";

export const customRoutes = [
  {
    path: routeNames.LANDING,
    name: "Signup",
    element: <Signup />,
    exact: true,
  },
  {
    path: routeNames.ASKLOCATION,
    name: "Allow Location",
    element: <AskLocation />,
    exact: true,
  },
  {
    path: routeNames.VENUES,
    name: "Venues",
    element: <Venues />,
    exact: true,
  },
  {
    path: routeNames.SUCCESS,
    name: "Signup Success",
    element: <SignupSuccess />,
    exact: true,
  },
  {
    path: routeNames.ALREADY_ENTERED,
    name: "Already entered",
    element: <AlreadyEntered />,
    exact: true,
  },
  {
    path: routeNames.SCAN,
    name: "Scan",
    element: <Scan />,
    exact: true,
  },
  {
    path: routeNames.WINNER,
    name: "Winner",
    element: <Winner />,
    exact: true,
  },
  {
    path: routeNames.NOT_WINNER,
    name: "Winner",
    element: <NotWinner />,
    exact: true,
  },
  {
    path: routeNames.PREENTRY,
    name: "Pre Entry",
    element: <PreEntry />,
    exact: true,
  },
  {
    path: routeNames.OUTHOURS,
    name: "Out Of Hours",
    element: <OutOfHours />,
    exact: true,
  },
  {
    path: routeNames.CLOSED,
    name: "Closed",
    element: <Closed />,
    exact: true,
  },
  {
    path: routeNames.TERMS,
    name: "Terms & Conditions",
    element: <Terms />,
    exact: true,
  },
  {
    path: routeNames.PRIVACY,
    name: "Privacy Policy",
    element: <Privacy />,
    exact: true,
  },
  {
    path: routeNames.COOKIES,
    name: "Cookie Policy",
    element: <Cookies />,
    exact: true,
  },
];
